import styled from 'styled-components';
import { styled as Styled } from '@mui/material/styles';
import { Box, Card, Avatar, Typography } from '@mui/material';

interface ModeProps {
  isDarkTheme?: boolean;
}

export const Audio = styled.audio`
  display: none;
`;

export const StyledCard = Styled(Card, {
  shouldForwardProp: (prop) => prop !== 'isDarkTheme',
})<ModeProps>(({ theme, isDarkTheme = false }) => ({
  minWidth: 380,
  maxWidth: 480,
  display: 'flex',
  borderRadius: 12,
  flexDirection: 'column',
  boxShadow: theme.shadows[6],
  padding: theme.spacing(2.5, 3),
  background: isDarkTheme ? '#383838' : '#ffffff',
}));

export const HeaderRow = Styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const InfoRow = Styled(Box)({
  gap: '12px',
  display: 'flex',
  alignItems: 'center',
});

export const AvatarBox = Styled(Avatar, {
  shouldForwardProp: (prop) => prop !== 'isDarkTheme',
})<ModeProps>(({ isDarkTheme = false }) => ({
  width: 40,
  height: 40,
  color: '#fff',
  fontSize: '1rem',
  boxShadow: isDarkTheme
    ? '0 2px 8px rgba(35, 39, 47, 0.25)'
    : '0 2px 8px rgba(25, 118, 210, 0.15)',
  background: isDarkTheme
    ? 'linear-gradient(135deg, #23272f 0%, #3a3f4b 100%)'
    : 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
}));

export const NameText = Styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isDarkTheme',
})<ModeProps>(({ isDarkTheme = false }) => ({
  fontWeight: 600,
  fontSize: '1rem',
  color: isDarkTheme ? '#fff' : '#222',
}));

export const RoleText = Styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isDarkTheme',
})<ModeProps>(({ isDarkTheme = false }) => ({
  fontSize: '0.9rem',
  color: isDarkTheme ? '#aaa' : '#777',
}));

export const MessageText = Styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isDarkTheme',
})<ModeProps>(({ isDarkTheme = false }) => ({
  marginTop: 12,
  marginBottom: 4,
  fontSize: '1rem',
  whiteSpace: 'pre-wrap',
  alignSelf: 'flex-start',
  wordBreak: 'break-word',
  maxWidth: 'calc(100% - 64px)',
  color: isDarkTheme ? '#e0e0e0' : '#222',
}));

export const ReplySender = Styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isDarkTheme',
})<ModeProps>(({ theme, isDarkTheme = false }) => ({
  marginTop: 4, // small spacing between user message and sender
  marginRight: 12,
  fontWeight: 600,
  lineHeight: 1.2,
  letterSpacing: 0.3,
  fontSize: '0.75rem', // ~12px
  alignSelf: 'flex-end',
  textTransform: 'uppercase',
  marginBottom: theme.spacing(0.5),
  color: isDarkTheme ? '#cccccc' : '#444444',
}));

export const UserReplyText = Styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isDarkTheme',
})<ModeProps>(({ theme, isDarkTheme = false }) => ({
  marginRight: 12,
  lineHeight: 1.5,
  borderRadius: 14,
  fontSize: '0.95rem',
  alignSelf: 'flex-end',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  maxWidth: 'calc(100% - 64px)', // avoids overflowing under close icon
  padding: theme.spacing(1.25, 2),
  color: isDarkTheme ? '#f5f5f5' : '#0a0a0a',
  backgroundColor: isDarkTheme ? '#2e2e2e' : '#e0f2fe',
  boxShadow: isDarkTheme
    ? '0 2px 6px rgba(0, 0, 0, 0.5)'
    : '0 2px 6px rgba(0, 0, 0, 0.1)',
}));
